import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import { Link, Redirect } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/modal.css";
import COLORS from "../resources/colors/COLORS";
import myToast from "../Utils/MyToast";
import SelectClass from "../ChildComponent/SelectClass";

const MdlSelectMultipleStudent = ({ actionClose, actionHandleSelected }) => {
  const slt_board = useRef();
  const slt_medium = useRef();
  const slt_class = useRef();
  const slt_section = useRef();

  const [loggedIn, setLoggedIn] = useState(
    localStorage.getItem("token") !== null
  );
  const [loading, setLoading] = useState(false);
  const [loadingStudent, setLoadingStudent] = useState(false);
  const [show, setShow] = useState(true);
  const [selectedClassPosition, setSelectedClassPosition] = useState(0);
  const [studentList, setStudentList] = useState([]);
  const [mSelectedStudent, setMSelectedStudent] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [sortBy, setSortBy] = useState(null); // null, 'name', or 'rollNo'

  useEffect(() => {
    localStorage.setItem("SelectedMultipleStudent", JSON.stringify([]));
  }, []);

  const callBackClassSelect = (
    class_id,
    section_id,
    session_id,
    selected_position,
    class_name,
    section_name,
    session_name
  ) => {
    setMSelectedStudent([]);
    localStorage.setItem("SelectedMultipleStudent", JSON.stringify([]));
    setSelectAll(false);
    setSortBy(null); // Reset sort when class changes

    setSelectedClassPosition(selected_position);
    getStudentList(class_id, section_id, session_id);
  };

  const getStudentList = (class_id, section_id, session_id) => {
    setLoadingStudent(true);
    setStudentList([]);

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getCurrentStudent.php?";
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          class_id,
          section_id,
          session_id,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoadingStudent(false);
        if (response.api_status === "OK") {
          setStudentList(response.data);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoadingStudent(false);
        console.error("Error fetching students:", error);
      });
  };

  const handleStudentSelection = (e, index) => {
    const isChecked = e.target.checked;
    const student = studentList[index];
    let updatedSelectedStudents = [...mSelectedStudent];

    if (isChecked) {
      updatedSelectedStudents.push(student);
    } else {
      updatedSelectedStudents = updatedSelectedStudents.filter(
        (s) => s.student_enrollment_no !== student.student_enrollment_no
      );
    }

    setMSelectedStudent(updatedSelectedStudents);
    localStorage.setItem(
      "SelectedMultipleStudent",
      JSON.stringify(updatedSelectedStudents)
    );
    
    // Update selectAll state based on selection
    if (updatedSelectedStudents.length === studentList.length && studentList.length > 0) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  };
  const handleSelectAll = () => {
    if (!selectAll) {
      setMSelectedStudent(studentList);
      localStorage.setItem(
        "SelectedMultipleStudent",
        JSON.stringify(studentList)
      );
    } else {
      setMSelectedStudent([]);
      localStorage.setItem("SelectedMultipleStudent", JSON.stringify([]));
    }
    setSelectAll(!selectAll);
  };

  const handleSort = (sortType) => {
    if (sortBy === sortType) {
      // If already sorted by this type, reverse the order
      setStudentList([...studentList].reverse());
    } else {
      // Sort by the selected type
      const sorted = [...studentList].sort((a, b) => {
        if (sortType === 'name') {
          return (a.stu_name || '').localeCompare(b.stu_name || '');
        } else if (sortType === 'rollNo') {
          const rollA = parseInt(a.student_roll_no) || 0;
          const rollB = parseInt(b.student_roll_no) || 0;
          return rollA - rollB;
        }
        return 0;
      });
      setStudentList(sorted);
      setSortBy(sortType);
    }
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  return (
    <div>
      <style>
        {`
          .modal-dialog-centered {
            max-width: 1200px !important;
            width: 95% !important;
            max-height: 90vh !important;
          }
          .modal-dialog-centered .modal-content {
            border-radius: 20px 20px 8px 8px;
            overflow: hidden;
            max-height: 90vh;
            display: flex;
            flex-direction: column;
          }
          .modal-dialog-centered .modal-header {
            border-radius: 20px 20px 0 0;
          }
          .modal-dialog-centered .modal-body {
            flex: 1 1 auto;
            overflow-y: auto;
          }
        `}
      </style>
      <Modal
        show={show}
        onHide={actionClose}
        animation={false}
        className="hide-scrollbar"
        dialogClassName="modal-dialog-centered"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header
          style={{
            background: COLORS.primary_color_shade5,
            color: COLORS.white,
          }}
        >
          <Modal.Title>Select Students</Modal.Title>
          <div style={{ display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>
            <div className="text-white fw-bold" style={{ fontSize: "1.2rem" }}>
              Selected Students: {mSelectedStudent.length}
            </div>
            <div style={{ display: "flex", gap: "8px", alignItems: "center", borderLeft: "1px solid rgba(255,255,255,0.3)", paddingLeft: "12px" }}>
              <span className="text-white" style={{ fontSize: "0.9rem", fontWeight: "600" }}>Sort By:</span>
              <button
                onClick={() => handleSort('name')}
                style={{
                  background: sortBy === 'name' 
                    ? `linear-gradient(135deg, ${COLORS.highlight_color2} 0%, #FFD700 100%)`
                    : "rgba(255, 255, 255, 0.1)",
                  border: sortBy === 'name' 
                    ? `3px solid ${COLORS.highlight_color2}`
                    : "3px solid rgba(255, 255, 255, 0.5)",
                  color: sortBy === 'name' ? "#000" : "#fff",
                  fontSize: "0.85rem",
                  fontWeight: "600",
                  height: "32px",
                  padding: "0 14px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  transition: "all 0.3s ease",
                  boxShadow: sortBy === 'name' 
                    ? `0 4px 12px ${COLORS.highlight_color2}50`
                    : "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
                onMouseEnter={(e) => {
                  if (sortBy !== 'name') {
                    e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)";
                    e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.5)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (sortBy !== 'name') {
                    e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
                    e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.3)";
                  }
                }}
                title="Sort by Name"
              >
                <i className="fa fa-sort-alpha-asc" />
                Name
              </button>
              <button
                onClick={() => handleSort('rollNo')}
                style={{
                  background: sortBy === 'rollNo' 
                    ? `linear-gradient(135deg, ${COLORS.highlight_color2} 0%, #FFD700 100%)`
                    : "rgba(255, 255, 255, 0.1)",
                  border: sortBy === 'rollNo' 
                    ? `3px solid ${COLORS.highlight_color2}`
                    : "3px solid rgba(255, 255, 255, 0.5)",
                  color: sortBy === 'rollNo' ? "#000" : "#fff",
                  fontSize: "0.85rem",
                  fontWeight: "600",
                  height: "32px",
                  padding: "0 14px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  transition: "all 0.3s ease",
                  boxShadow: sortBy === 'rollNo' 
                    ? `0 4px 12px ${COLORS.highlight_color2}50`
                    : "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
                onMouseEnter={(e) => {
                  if (sortBy !== 'rollNo') {
                    e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)";
                    e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.5)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (sortBy !== 'rollNo') {
                    e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
                    e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.3)";
                  }
                }}
                title="Sort by Roll Number"
              >
                <i className="fa fa-sort-numeric-asc" />
                RollNo
              </button>
            </div>
            <button
              onClick={handleSelectAll}
              style={{
                background: `linear-gradient(135deg, ${COLORS.highlight_color2} 0%, #FFD700 100%)`,
                border: `3px solid ${COLORS.highlight_color2}`,
                color: "#000",
                fontSize: "0.95rem",
                fontWeight: "700",
                height: "32px",
                padding: "0 16px",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                transition: "all 0.3s ease",
                boxShadow: `0 4px 12px ${COLORS.highlight_color2}50`,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = `0 6px 16px ${COLORS.highlight_color2}70`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = `0 4px 12px ${COLORS.highlight_color2}50`;
              }}
            >
              <i className={`fa ${selectAll ? "fa-check-square" : "fa-square"}`} />
              {selectAll ? "Deselect All" : "Select All"}
            </button>
            <button
              onClick={() => actionHandleSelected(mSelectedStudent)}
              disabled={mSelectedStudent.length === 0}
              style={{
                background: mSelectedStudent.length === 0
                  ? "rgba(255, 255, 255, 0.2)"
                  : `linear-gradient(135deg, ${COLORS.highlight_color2} 0%, #FFD700 100%)`,
                border: mSelectedStudent.length === 0
                  ? "3px solid rgba(255, 255, 255, 0.5)"
                  : `3px solid ${COLORS.highlight_color2}`,
                color: mSelectedStudent.length === 0 
                  ? "rgba(255, 255, 255, 0.5)" 
                  : "#000",
                fontSize: "1rem",
                fontWeight: "700",
                height: "32px",
                padding: "0 20px",
                borderRadius: "8px",
                cursor: mSelectedStudent.length === 0 ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                transition: "all 0.3s ease",
                boxShadow: mSelectedStudent.length === 0
                  ? "none"
                  : `0 4px 12px ${COLORS.highlight_color2}50`,
                opacity: mSelectedStudent.length === 0 ? 0.6 : 1,
              }}
              onMouseEnter={(e) => {
                if (mSelectedStudent.length > 0) {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = `0 6px 16px ${COLORS.highlight_color2}70`;
                }
              }}
              onMouseLeave={(e) => {
                if (mSelectedStudent.length > 0) {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = `0 4px 12px ${COLORS.highlight_color2}50`;
                }
              }}
            >
              <i className="fa fa-check-circle" />
              Done
            </button>
            <button
              onClick={actionClose}
              style={{
                background: `linear-gradient(135deg, ${COLORS.highlight_color2} 0%, #FFD700 100%)`,
                border: `3px solid ${COLORS.highlight_color2}`,
                color: "#000",
                fontSize: "1.3rem",
                fontWeight: "700",
                width: "32px",
                height: "32px",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.3s ease",
                boxShadow: `0 4px 12px ${COLORS.highlight_color2}50`,
                lineHeight: "1",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px) rotate(90deg)";
                e.currentTarget.style.boxShadow = `0 6px 16px ${COLORS.highlight_color2}70`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0) rotate(0deg)";
                e.currentTarget.style.boxShadow = `0 4px 12px ${COLORS.highlight_color2}50`;
              }}
              title="Close"
            >
              &times;
            </button>
          </div>
        </Modal.Header>
        <Modal.Body className="hide-scrollbar" style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {loading && (
            <div>
              <MyLoader />
            </div>
          )}
          <div className="row settings-scroll">
            <div className="col-12 padding_0">
              <SelectClass
                action={callBackClassSelect}
                selected_position={selectedClassPosition}
              />
              
              
              <div className="row bg_card_primary_outline" style={{ margin: "5px 0px", padding: "5px" }}>
                {loadingStudent ? (
                  <div className="col-12 text-center">
                    <MyLoader />
                  </div>
                ) : (
                  studentList.map((item, index) => {
                    const isSelected = mSelectedStudent.some((s) => s.student_enrollment_no === item.student_enrollment_no);
                    return (
                      <div key={index} className="col-6 padding_0" style={{ padding: "6px" }}>
                        <div
                          style={{
                            background: isSelected
                              ? `linear-gradient(135deg, ${COLORS.primary_color_shade1} 0%, ${COLORS.white} 100%)`
                              : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                            border: isSelected
                              ? `2px solid ${COLORS.primary_color_shade6}`
                              : "2px solid #e5e7eb",
                            borderRadius: "12px",
                            padding: "16px",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            boxShadow: isSelected
                              ? `0 4px 12px ${COLORS.primary_color_shade3}40`
                              : "0 2px 4px rgba(0, 0, 0, 0.05)",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            handleStudentSelection({ target: { checked: !isSelected } }, index);
                          }}
                          onMouseEnter={(e) => {
                            if (!isSelected) {
                              e.currentTarget.style.borderColor = COLORS.primary_color_shade4;
                              e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                              e.currentTarget.style.transform = "translateY(-2px)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isSelected) {
                              e.currentTarget.style.borderColor = "#e5e7eb";
                              e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                              e.currentTarget.style.transform = "";
                            }
                          }}
                        >
                          {isSelected && (
                            <div style={{
                              position: "absolute",
                              top: "8px",
                              right: "8px",
                              width: "32px",
                              height: "32px",
                              borderRadius: "50%",
                              background: COLORS.primary_color_shade6,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: `0 2px 6px ${COLORS.primary_color_shade3}40`,
                              zIndex: 10,
                            }}>
                              <i className="fa fa-check" style={{ color: "#fff", fontSize: "16px", fontWeight: "bold" }} />
                            </div>
                          )}
                          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                            {/* Student Image with Modern Frame */}
                            <div style={{
                              position: "relative",
                              width: "80px",
                              height: "80px",
                              flexShrink: 0,
                            }}>
                              <div style={{
                                position: "absolute",
                                inset: "-4px",
                                borderRadius: "50%",
                                background: `linear-gradient(135deg, ${COLORS.white} 0%, ${COLORS.primary_color_shade1} 100%)`,
                                padding: "3px",
                                boxShadow: `0 4px 12px ${COLORS.primary_color_shade3}60`,
                              }}>
                                <div style={{
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "50%",
                                  background: "#fff",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  overflow: "hidden",
                                }}>
                                  <img 
                                    src={item.student_img_path} 
                                    alt={item.stu_name}
                                    style={{ 
                                      width: "100%", 
                                      height: "100%", 
                                      objectFit: "cover",
                                      borderRadius: "50%",
                                    }}
                                    onError={(e) => {
                                      e.target.style.display = "none";
                                      if (e.target.nextSibling) {
                                        e.target.nextSibling.style.display = "flex";
                                      }
                                    }}
                                  />
                                  <div style={{
                                    display: "none",
                                    width: "100%",
                                    height: "100%",
                                    background: `linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade4} 100%)`,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#fff",
                                    fontSize: "32px",
                                    fontWeight: "700",
                                  }}>
                                    {item.stu_name?.charAt(0)?.toUpperCase() || "S"}
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            {/* Student Info */}
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                marginBottom: "8px",
                              }}>
                                <h5 style={{ 
                                  margin: 0, 
                                  fontSize: "16px", 
                                  fontWeight: "700", 
                                  color: COLORS.black8 || "#333333",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}>
                                  <i className="fa fa-user" style={{ fontSize: "14px", color: COLORS.primary_color_shade6 }} />
                                  {item.stu_name}
                                </h5>
                              </div>
                              {item.father_name && (
                                <div style={{
                                  fontSize: "12px",
                                  color: "#6b7280",
                                  marginBottom: "10px",
                                  fontWeight: "500",
                                }}>
                                  <i className="fa fa-male" style={{ marginRight: "6px", fontSize: "11px", color: COLORS.primary_color_shade6 }} />
                                  {item.father_name}
                                </div>
                              )}
                              <div style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "8px",
                                alignItems: "center",
                              }}>
                                <div style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  padding: "4px 10px",
                                  background: COLORS.primary_color_shade1 || "#B3E5FC",
                                  borderRadius: "6px",
                                  border: `1px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
                                }}>
                                  <i className="fa fa-hashtag" style={{ color: COLORS.primary_color_shade8 || "#0277BD", fontSize: "10px" }} />
                                  <span style={{ fontSize: "12px", fontWeight: "600", color: COLORS.black8 || "#333333" }}>
                                    RollNo: {item.student_roll_no}
                                  </span>
                                </div>
                                <div style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  padding: "4px 10px",
                                  background: COLORS.primary_color_shade1 || "#B3E5FC",
                                  borderRadius: "6px",
                                  border: `1px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
                                }}>
                                  <i className="fa fa-graduation-cap" style={{ color: COLORS.primary_color_shade8 || "#0277BD", fontSize: "10px" }} />
                                  <span style={{ fontSize: "12px", fontWeight: "600", color: COLORS.black8 || "#333333" }}>
                                    Class: {item.section_id === "No" ? item.class_name : `${item.class_name}:${item.section_name}`}
                                  </span>
                                </div>
                                {item.sr_admission_no && (
                                  <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    padding: "4px 10px",
                                    background: COLORS.primary_color_shade1 || "#B3E5FC",
                                    borderRadius: "6px",
                                    border: `1px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
                                  }}>
                                    <i className="fa fa-id-card" style={{ color: COLORS.primary_color_shade8 || "#0277BD", fontSize: "10px" }} />
                                    <span style={{ fontSize: "12px", fontWeight: "600", color: COLORS.black8 || "#333333" }}>
                                      SRN: {item.sr_admission_no}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MdlSelectMultipleStudent;
